<template>
    <div class="msg">
        <div class="user-mes-box">
            <div class="user-mes-title" v-text="addText"></div>
            <div class="user-mes">
                <div class="user-mes-in cle" style="height:auto;">
                    <div class="user-mes-in cle" style="height:auto;" v-show="isSub">
                        <div :title="shareCh" v-text="shareCh" class="user-mes-name fl"></div>
                        <input class="fr cle" type="text" disabled :value="chV" style="width:calc(100% - 120px - 20px);">
                    </div>
                    <div v-text="shareTime" :title="shareTime" style="height:30px;" class="user-mes-name fl"></div>
                    <div class="fr" style="width:calc(100% - 120px - 20px);">
                        <div class="share-time-box cle">
                            <input class="user-mes-inp fl" maxlength="2" v-model="timeH1" @keyup="hourLimit('H1')" @blur="hourLimits('H1')" type="text">
                            <span class="share-time-sym fl">:</span>
                            <input class="user-mes-inp fl" maxlength="2" v-model="timeM1" @keyup="minLimit('H1')" @blur="minLimits('H1')" type="text">
                            <span class="share-time-sym fl">--</span>
                            <input class="user-mes-inp fl" maxlength="2" v-model="timeH2" @keyup="hourLimit('H2')" @blur="hourLimits('H2')" type="text">
                            <span class="share-time-sym fl">:</span>
                            <input class="user-mes-inp fl" maxlength="2" v-model="timeM2" @keyup="minLimit('H2')" @blur="minLimits('H2')" type="text">
                            <button type="button" class="share-time-btn fl" :title="add" v-text="add" @click="shareTimeAdd"></button>
                        </div>
                        <div v-for="(item,index) in shareTimeArr" :key="index" class="share-time-top">
                            <div v-if="item.show" class="share-time-box cle">
                                <input class="user-mes-inp fl" maxlength="2" v-model="item.hs" @keyup="hourLimit('A'+index)" @blur="hourLimits('A'+index)" type="text">
                                <span class="share-time-sym fl">:</span>
                                <input class="user-mes-inp fl" maxlength="2" v-model="item.ms" @keyup="minLimit('A'+index)" @blur="minLimits('A'+index)" type="text">
                                <span class="share-time-sym fl">--</span>
                                <input class="user-mes-inp fl" maxlength="2" v-model="item.he" @keyup="hourLimit('A'+(index+2))" @blur="hourLimits('A'+(index+2))" type="text">
                                <span class="share-time-sym fl">:</span>
                                <input class="user-mes-inp fl" maxlength="2" v-model="item.me" @keyup="minLimit('A'+(index+2))" @blur="minLimits('A'+(index+2))" type="text">
                                <button type="button" class="share-time-btn fl" :title="del" v-text="del" @click="shareTimeDel"></button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="user-mes-in cle" style="height:auto;">
                    <div :title="repeat" v-text="repeat" class="user-mes-name fl"></div>
                    <div class="fr cle" style="width:calc(100% - 120px - 20px);">
                        <button type="button" v-for="(item,index) in day" :key="index" :class="item.name" :title="item.day" v-text="item.day" @click="changeBtn('day',day,index)"></button>
                    </div>
                </div>
                <div class="user-mes-in cle">
                    <div :title="sharePower" v-text="sharePower" class="user-mes-name fl"></div>
                    <div class="fr cle" style="width:calc(100% - 120px - 20px);">
                        <button type="button" v-for="(item,index) in power" :key="index" :class="item.name" :title="item.txt" :dis="index===0?index:1" v-text="item.txt" @click="changeBtn('power',power,index)"></button>
                    </div>
                </div>
                <div class="user-mes-btn cle">
                    <button type="button" class="fl" :title="confirmText" @click="confirm" v-text="confirmText"></button>
                    <button type="button" class="fr" :title="cancelText" @click="cancel" v-text="cancelText"></button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import share from '../assets/js/share'
export default {
    name:'ShareToFriend',
    props:['language'],
    data(){
        return{
            id:'',
            addText:'',
            shareCh:'',
            confirmText:'',
            cancelText:'',
            friendTxt:'',
            friend:'',
            shareTime:'',
            add:'',
            del:'',
            repeat:'',
            addShareTime:1,
            sharePower:'',
            day:[],
            dayInit:[],
            power:[],
            powerInit:[],
            nameArr:[],
            mes:[],
            shareTimeArrInit:[
                {show:false,hs:'00',ms:'00',he:'23',me:'59'},
                {show:false,hs:'00',ms:'00',he:'23',me:'59'}
            ],
            shareTimeArr:[
                {show:false,hs:'00',ms:'00',he:'23',me:'59'},
                {show:false,hs:'00',ms:'00',he:'23',me:'59'}
            ],
            timeH1:'00',
            timeM1:'00',
            timeH2:'23',
            timeM2:'59',
            addShareText:'',
            cancelShareText:'',
            isHs:0,
            accountId:'',
            account:'',
            powers:'',
            weekdays:'',
            periods:'',
            default:true,
            isSub:false,
            chV:''
        }
    },
    methods:{
        confirm:function(){
            this.ajaxH.repeat=this.confirmAfter;
            this.$emit('refresh');
        },
        confirmAfter:function(){
            this.$nextTick(function(){
                if(!this.default){
                    var power=[];
                    for(var i=0;i<this.power.length;i++){
                        if(this.power[i].name.indexOf('share-choice')!==-1){
                            if(i===0){
                                power.push(1);
                            };
                            if(i===1){
                                power.push(3);
                            };
                            if(i===2){
                                power.push(4);
                            };
                        };
                    };
                    var weekdays=[];
                    for(var i=0;i<this.day.length;i++){
                        if(this.day[i].name.indexOf('share-choice')!==-1){
                            weekdays.push(i);
                        };
                    };
                    var time='';
                    var ss='00';
                    var se='00';
                    if(this.addShareTime>=1){
                        ss='00';
                        if(this.timeH1===23&&this.timeM1===59){
                            ss='59';
                        };
                        se='00';
                        if(this.timeH2===23&&this.timeM2===59){
                            se='59';
                        };
                        time=this.timeH1+':'+this.timeM1+':'+ss+'-'+this.timeH2+':'+this.timeM2+':'+se;
                        if(this.timeH1*60*60+this.timeM1*60+ss*1>=this.timeH2*60*60+this.timeM2*60+se*1){
                            alert(this.language['K159_Time']);
                            return false;
                        };
                    };
                    if(this.addShareTime>=2){
                        ss='00';
                        if(this.shareTimeArr[0].hs===23&&this.shareTimeArr[0].ms===59){
                            ss='59';
                        };
                        se='00';
                        if(this.shareTimeArr[0].he===23&&this.shareTimeArr[0].me===59){
                            se='59';
                        };
                        time+=','+this.shareTimeArr[0].hs+':'+this.shareTimeArr[0].ms+':'+ss+'-'+this.shareTimeArr[0].he+':'+this.shareTimeArr[0].me+':'+se;
                        if(this.shareTimeArr[0].hs*60*60+this.shareTimeArr[0].ms*60+ss*1>=this.shareTimeArr[0].he*60*60+this.shareTimeArr[0].me*60+se*1){
                            alert(this.language['K159_Time']);
                            return false;
                        };
                    };
                    if(this.addShareTime===3){
                        ss='00';
                        if(this.shareTimeArr[1].hs===23&&this.shareTimeArr[1].ms===59){
                            ss='59';
                        };
                        se='00';
                        if(this.shareTimeArr[1].he===23&&this.shareTimeArr[1].me===59){
                            se='59';
                        };
                        time+=','+this.shareTimeArr[1].hs+':'+this.shareTimeArr[1].ms+':'+ss+'-'+this.shareTimeArr[1].he+':'+this.shareTimeArr[1].me+':'+se;
                        if(this.shareTimeArr[1].hs*60*60+this.shareTimeArr[1].ms*60+ss*1>=this.shareTimeArr[1].he*60*60+this.shareTimeArr[1].me*60+se*1){
                            alert(this.language['K159_Time']);
                            return false;
                        };
                    };
                    if(this.isSub){
                        var chA=(this.chV+'').split(',');
                        var itemA=[];
                        chA.forEach(function(v){
                            itemA.push({
                                subcode:'ch'+v,
                                weekdays:weekdays.join(','),
                                periods:time,
                                powers:power.join(',')
                            });
                        });
                        var timeStr=share.subdevShare({
                            sessionId:this.ajaxH.session,
                            oem:this.baseData.oem,
                            accountId:this.accountId,
                            id:this.id,
                            name:this.name,
                            item:itemA
                        });
                        var sendTimeData=this.ajaxSet({
                            ip:this.cloudName,
                            type:'auth/user',
                            xml:JSON.stringify(timeStr),
                            cType:'json'
                        });
                        this.confirmChangeResult(sendTimeData,'json');
                    }else{
                        var timeStr=share.changeTime({
                            sessionId:this.ajaxH.session,
                            oem:this.baseData.oem,
                            accountId:this.accountId,
                            account:this.account,
                            id:this.id,
                            isHs:this.isHs,
                            weekdays:weekdays.join(','),
                            periods:time
                        });
                        var powerStr=share.changePower({
                            sessionId:this.ajaxH.session,
                            oem:this.baseData.oem,
                            accountId:this.accountId,
                            account:this.account,
                            id:this.id,
                            isHs:this.isHs,
                            powers:power.join(',')
                        });
                        var sendTimeData=this.ajaxSet({
                            ip:this.cloudName,
                            type:'auth/user',
                            xml:timeStr
                        });
                        var sendPowerData=this.ajaxSet({
                            ip:this.cloudName,
                            type:'auth/user',
                            xml:powerStr
                        });
                        this.confirmChangeResult([{data:sendTimeData.xhr.responseText},{data:sendPowerData.xhr.responseText}]);
                    };
                }else{
                    var power=[];
                    for(var i=0;i<this.power.length;i++){
                        if(this.power[i].name.indexOf('share-choice')!==-1){
                            if(i===0){
                                power.push(1);
                            };
                            if(i===1){
                                power.push(3);
                            };
                            if(i===2){
                                power.push(4);
                            };
                        };
                    };
                    var weekdays=[];
                    for(var i=0;i<this.day.length;i++){
                        if(this.day[i].name.indexOf('share-choice')!==-1){
                            weekdays.push(i);
                        };
                    };
                    var time='';
                    var ss='00';
                    var se='00';
                    if(this.addShareTime>=1){
                        ss='00';
                        if(this.timeH1===23&&this.timeM1===59){
                            ss='59';
                        };
                        se='00';
                        if(this.timeH2===23&&this.timeM2===59){
                            se='59';
                        };
                        time=this.timeH1+':'+this.timeM1+':'+ss+'-'+this.timeH2+':'+this.timeM2+':'+se;
                        if(this.timeH1*60*60+this.timeM1*60+ss*1>=this.timeH2*60*60+this.timeM2*60+se*1){
                            alert(this.language['K159_Time']);
                            return false;
                        };
                    };
                    if(this.addShareTime>=2){
                        ss='00';
                        if(this.shareTimeArr[0].hs===23&&this.shareTimeArr[0].ms===59){
                            ss='59';
                        };
                        se='00';
                        if(this.shareTimeArr[0].he===23&&this.shareTimeArr[0].me===59){
                            se='59';
                        };
                        time+=','+this.shareTimeArr[0].hs+':'+this.shareTimeArr[0].ms+':'+ss+'-'+this.shareTimeArr[0].he+':'+this.shareTimeArr[0].me+':'+se;
                        if(this.shareTimeArr[0].hs*60*60+this.shareTimeArr[0].ms*60+ss*1>=this.shareTimeArr[0].he*60*60+this.shareTimeArr[0].me*60+se*1){
                            alert(this.language['K159_Time']);
                            return false;
                        };
                    };
                    if(this.addShareTime===3){
                        ss='00';
                        if(this.shareTimeArr[1].hs===23&&this.shareTimeArr[1].ms===59){
                            ss='59';
                        };
                        se='00';
                        if(this.shareTimeArr[1].he===23&&this.shareTimeArr[1].me===59){
                            se='59';
                        };
                        time+=','+this.shareTimeArr[1].hs+':'+this.shareTimeArr[1].ms+':'+ss+'-'+this.shareTimeArr[1].he+':'+this.shareTimeArr[1].me+':'+se;
                        if(this.shareTimeArr[1].hs*60*60+this.shareTimeArr[1].ms*60+ss*1>=this.shareTimeArr[1].he*60*60+this.shareTimeArr[1].me*60+se*1){
                            alert(this.language['K159_Time']);
                            return false;
                        };
                    };
                    if(this.isSub){
                        var chA=(this.chV+'').split(',');
                        var itemA=[];
                        chA.forEach(function(v){
                            itemA.push({
                                subcode:'ch'+v,
                                weekdays:weekdays.join(','),
                                periods:time,
                                powers:power.join(','),
                                channel:v,
                                index:v-1
                            });
                        });
                        var timeStr=share.subdevShare({
                            sessionId:this.ajaxH.session,
                            oem:this.baseData.oem,
                            accountId:this.accountId,
                            id:this.id,
                            name:this.name,
                            item:itemA
                        });
                        var data=this.ajaxSet({
                            ip:this.cloudName,
                            type:'auth/user',
                            xml:JSON.stringify(timeStr),
                            cType:'json'
                        });
                        this.deviceShareSetResult(data.data,'json');
                    }else{
                        var shareSetStr=share.deviceShareSet({
                            sessionId:this.ajaxH.session,
                            oem:this.baseData.oem,
                            accountId:this.accountId,
                            account:this.account,
                            id:this.id,
                            powers:power.join(','),
                            weekdays:weekdays.join(','),
                            periods:time,
                            isHs:this.isHs
                        });
                        var data=this.ajaxSet({
                            ip:this.cloudName,
                            type:'auth/user',
                            xml:shareSetStr
                        });
                        this.deviceShareSetResult(data.data);
                    };
                };
            });
        },
        confirmChangeResult:function(arr,type){
            if(type==='json'){
                var resultTime=arr.data.header.result-0;
                var resultPower=arr.data.header.result-0;
            }else{
                var dataTime=$.parseXML(arr[0].data);
                var dataPower=$.parseXML(arr[1].data);
                var resultTime=$(dataTime).find('result').text()-0;
                var resultPower=$(dataPower).find('result').text()-0;
            };
            if(resultTime ===0&&resultPower===0){
                alert(this.language['K116_Modify_Successfully']);
                this.$emit('refresh');
            }else if(resultTime !==0&&resultPower===0){
                var key = this.promptInfo(resultTime);
                alert(this.language[key] == undefined ? key : this.language[key]);
            }else if(resultTime ===0&&resultPower!==0){
                var key = this.promptInfo(resultPower);
                alert(this.language[key] == undefined ? key : this.language[key]);
            }else if(resultTime !==0&&resultPower!==0){
                alert(this.language['K143_setFail']);
            };
            this.$emit('close');
        },
        deviceShareSetResult:function(data,type){
            if(type==='json'){
                var result=data.header.result-0;
            }else{
                var result=$(data).find('result').text()-0;
            };
            if(result === 0){
                alert(this.language['K116_Modify_Successfully']);
                this.$emit('refresh');
            }else{
                var key = this.promptInfo(result);
                alert(this.language[key] == undefined ? key : this.language[key]);
            };
            this.$emit('close');
        },
        cancel:function(){
            this.$emit('close');
        },
        hourLimit:function(v){
            var reg=/\d+/;
            var value='';
            if(v=='H1'){
                value=this.timeH1;
            };
            if(v=='H2'){
                value=this.timeH2;
            };
            if(v=='A0'){
                value=this.shareTimeArr[0].hs;
            };
            if(v=='A1'){
                value=this.shareTimeArr[1].hs;
            };
            if(v=='A2'){
                value=this.shareTimeArr[0].he;
            };
            if(v=='A3'){
                value=this.shareTimeArr[1].he;
            };
            var val=reg.exec(value);
            if(val===null){
                value='';
            }else{
                if(val-0>=10&&val-0<=23){
                    value=val-0;
                }else if(val-0<0){
                    value='00';
                }else if(val-0>23){
                    value=23;
                };
            };
            if(v=='H1'){
                this.timeH1=value;
            };
            if(v=='H2'){
                this.timeH2=value;
            };
            if(v=='A0'){
                this.shareTimeArr[0].hs=value;
            };
            if(v=='A1'){
                this.shareTimeArr[1].hs=value;
            };
            if(v=='A2'){
                this.shareTimeArr[0].he=value;
            };
            if(v=='A3'){
                this.shareTimeArr[1].he=value;
            };
        },
        hourLimits:function(v){
            var reg=/\d+/;
            var value='';
            if(v=='H1'){
                value=this.timeH1;
            };
            if(v=='H2'){
                value=this.timeH2;
            };
            if(v=='A0'){
                value=this.shareTimeArr[0].hs;
            };
            if(v=='A1'){
                value=this.shareTimeArr[1].hs;
            };
            if(v=='A2'){
                value=this.shareTimeArr[0].he;
            };
            if(v=='A3'){
                value=this.shareTimeArr[1].he;
            };
            var val=reg.exec(value);
            if(val===null){
                value='00';
            }else{
                if(val-0<10&&val-0>=0){
                    value='0'+(val-0);
                }else if(val-0>=10&&val-0<=23){
                    value=val-0;
                }else if(val-0<0){
                    value='00';
                }else if(val-0>23){
                    value=23;
                };
            };
            if(v=='H1'){
                this.timeH1=value;
            };
            if(v=='H2'){
                this.timeH2=value;
            };
            if(v=='A0'){
                this.shareTimeArr[0].hs=value;
            };
            if(v=='A1'){
                this.shareTimeArr[1].hs=value;
            };
            if(v=='A2'){
                this.shareTimeArr[0].he=value;
            };
            if(v=='A3'){
                this.shareTimeArr[1].he=value;
            };
        },
        minLimit:function(v){
            var reg=/\d+/;
            var value='';
            if(v=='H1'){
                value=this.timeM1;
            };
            if(v=='H2'){
                value=this.timeM2;
            };
            if(v=='A0'){
                value=this.shareTimeArr[0].ms;
            };
            if(v=='A1'){
                value=this.shareTimeArr[1].ms;
            };
            if(v=='A2'){
                value=this.shareTimeArr[0].me;
            };
            if(v=='A3'){
                value=this.shareTimeArr[1].me;
            };
            var val=reg.exec(value);
            if(val===null){
                value='';
            }else{
                if(val-0>=10&&val-0<=59){
                    value=val-0;
                }else if(val-0<0){
                    value='00';
                }else if(val-0>59){
                    value=59;
                };
            };
            if(v=='H1'){
                this.timeM1=value;
            };
            if(v=='H2'){
                this.timeM2=value;
            };
            if(v=='A0'){
                this.shareTimeArr[0].ms=value;
            };
            if(v=='A1'){
                this.shareTimeArr[1].ms=value;
            };
            if(v=='A2'){
                this.shareTimeArr[0].me=value;
            };
            if(v=='A3'){
                this.shareTimeArr[1].me=value;
            };
        },
        minLimits:function(v){
            var reg=/\d+/;
            var value='';
            if(v=='H1'){
                value=this.timeM1;
            };
            if(v=='H2'){
                value=this.timeM2;
            };
            if(v=='A0'){
                value=this.shareTimeArr[0].ms;
            };
            if(v=='A1'){
                value=this.shareTimeArr[1].ms;
            };
            if(v=='A2'){
                value=this.shareTimeArr[0].me;
            };
            if(v=='A3'){
                value=this.shareTimeArr[1].me;
            };
            var val=reg.exec(value);
            if(val===null){
                value='00';
            }else{
                if(val-0<10&&val-0>=0){
                    value='0'+(val-0);
                }else if(val-0>=10&&val-0<=59){
                    value=val-0;
                }else if(val-0<0){
                    value='00';
                }else if(val-0>59){
                    value=59;
                };
            };
            if(v=='H1'){
                this.timeM1=value;
            };
            if(v=='H2'){
                this.timeM2=value;
            };
            if(v=='A0'){
                this.shareTimeArr[0].ms=value;
            };
            if(v=='A1'){
                this.shareTimeArr[1].ms=value;
            };
            if(v=='A2'){
                this.shareTimeArr[0].me=value;
            };
            if(v=='A3'){
                this.shareTimeArr[1].me=value;
            };
        },
        shareTimeAdd:function(){
            this.addShareTime++;
            if(this.addShareTime===1){
                this.timeH1='00',
                this.timeM1='00';
                this.timeH2='23';
                this.timeM2='59';
                this.shareTimeArr[0].show=false;
                this.shareTimeArr[1].show=false;
            }else if(this.addShareTime===2){
                var time=JSON.parse(JSON.stringify(this.shareTimeArrInit));
                time[0].show=true;
                this.shareTimeArr=time;
            }else if(this.addShareTime===3){
                var time=JSON.parse(JSON.stringify(this.shareTimeArrInit));
                time[0]=this.shareTimeArr[0];
                time[0].show=true;
                time[1].show=true;
                this.shareTimeArr=time;
            }else{
                this.addShareTime=3;
                this.shareTimeArr[0].show=true;
                this.shareTimeArr[1].show=true;
            };
        },
        shareTimeDel:function(){
            this.addShareTime--;
            if(this.addShareTime===1){
                this.shareTimeArr[0].show=false;
                this.shareTimeArr[1].show=false;
            }else if(this.addShareTime===2){
                this.shareTimeArr[0].show=true;
                this.shareTimeArr[1].show=false;
            }else{
                this.addShareTime=1;
                this.shareTimeArr[0].show=false;
                this.shareTimeArr[1].show=false;
            };
        },
        changeBtn:function(type,arr,index){
            var name=arr[index].name.split(' ');
            var pos=name.indexOf('share-choice');
            if(type==='day'){
                if(pos===-1){
                    this.day[index].name=name.join(' ')+' share-choice';
                }else{
                    name.splice(pos,1);
                    this.day[index].name=name.join(' ');
                };
            };
            if(type==='power'){
                if(index===0){
                    return false;
                };
                if(pos===-1){
                    this.power[index].name=name.join(' ')+' share-choice';
                }else{
                    name.splice(pos,1);
                    this.power[index].name=name.join(' ');
                };
            };
        },
        getList:function(){
            this.deviceShareResult();
        },
        deviceShareResult:function(){
            var weekdays=this.weekdays.split(',');
            var day=JSON.parse(JSON.stringify(this.dayInit));
            for(var j=0;j<weekdays.length;j++){
                var index=weekdays[j]-0;
                day[index].name=day[index].name+' share-choice';
            };
            this.day=day;
            var powers=this.powers.split(',');
            var power=JSON.parse(JSON.stringify(this.powerInit));
            for(var p=0;p<powers.length;p++){
                var indexp=powers[p]-0;
                if(indexp===3){
                    power[1].name=power[1].name+' share-choice';
                }else if(indexp===4){
                    power[2].name=power[2].name+' share-choice';
                };
            };
            this.power=power;
            var periods=this.periods.split(',');
            this.addShareTime=periods.length-1;
            this.shareTimeAdd();
            for(var e=0;e<periods.length;e++){
                var periodsTime=periods[e];
                var time=periodsTime.split('-');
                var times=time[0].split(':');
                var timee=time[1].split(':');
                if(e===0){
                    this.timeH1=times[0];
                    this.timeM1=times[1];
                    this.timeH2=timee[0];
                    this.timeM2=timee[1];
                };
                if(e===1){
                    this.shareTimeArr[0].hs=times[0];
                    this.shareTimeArr[0].ms=times[1];
                    this.shareTimeArr[0].he=timee[0];
                    this.shareTimeArr[0].me=timee[1];
                };
                if(e===2){
                    this.shareTimeArr[1].hs=times[0];
                    this.shareTimeArr[1].ms=times[1];
                    this.shareTimeArr[1].he=timee[0];
                    this.shareTimeArr[1].me=timee[1];
                };
            };
        },
        getID:function(obj){
            this.id=obj.id;
            this.isHs=obj.isHs;
            this.friend=obj.name;
            this.accountId=obj.accountId;
            this.account=obj.account;
            this.powers=obj.power;
            this.weekdays=obj.weekdays;
            this.periods=obj.periods;
            this.isSub=obj.isSub;
            this.default=obj.default;
            this.name=obj.name;
            if(this.isSub){
                this.chV=obj.ch;
            }else{
                this.chV='';
            };
        },
        lang:function(){
            this.friendTxt=this.language['K124_ChoiceFriend'];
            this.addText=this.language['K126_ShareAdd'];
            this.shareCh=this.lanNow.lan["K223_Channel"];
            this.cancelShareText=this.language['K139_cancelShare'];
            this.addShareText=this.language['K140_addShare'];
            this.confirmText=this.language['K024_Confirm'];
            this.cancelText=this.language['K018_Cancel'];
            this.shareTime=this.language['K125_ShareTime'];
            this.add=this.language['K126_ShareAdd'];
            this.del=this.language['K037_Delete'];
            this.repeat=this.language['K127_ShareRepeat'];
            this.dayInit=[{
                day:this.language['K128_Sun'],
                name:'fl share-time-btns'
            },{
                day:this.language['K129_Mon'],
                name:'fl share-time-btns'
            },{
                day:this.language['K130_Tue'],
                name:'fl share-time-btns'
            },{
                day:this.language['K131_Wed'],
                name:'fl share-time-btns'
            },{
                day:this.language['K132_Thu'],
                name:'fl share-time-btns'
            },{
                day:this.language['K133_Fri'],
                name:'fl share-time-btns'
            },{
                day:this.language['K134_Sat'],
                name:'fl share-time-btns'
            }];
            this.day=JSON.parse(JSON.stringify(this.dayInit));
            this.powerInit=[{
                txt:this.language['K136_Preview'],
                name:'fl share-time-btns share-time-btn-day share-choice'
            },{
                txt:this.language['K137_Playback'],
                name:'fl share-time-btns share-time-btn-day'
            },{
                txt:this.language['K138_Alarm'],
                name:'fl share-time-btns share-time-btn-day'
            }];
            this.power=JSON.parse(JSON.stringify(this.powerInit));
            this.sharePower=this.language['K135_Power'];
            this.preview=this.language['K136_Preview'];
            this.playback=this.language['K137_Playback'];
            this.alarm=this.language['K138_Alarm'];
            this.$nextTick(function(){
                this.getList();
            });
        }
    }
}
</script>
<style scoped>
    .msg{
        position:fixed;
        top:0;
        left:0;
        right:0;
        bottom:0;
        background-color:rgba(0, 0, 0, .5);
    }
    .user-mes-box{
        width:540px;
        height:auto;
        background-color: #EFF2F9;
        font-size:12px;
        position:absolute;
        left:50%;
        margin-top:160px;
        margin-left:-240px;
    }
    .user-mes-title{
        width:100%;
        height:24px;
        line-height:24px;
        text-align: center;
        background-color: #364860;
        color:#fff;
    }
    .user-mes{
        width:100%;
        height:calc(100% - 24px);
        padding:20px;
        box-sizing: border-box;
    }
    .user-mes-in{
        width:100%;
        height:30px;
    }
    .user-mes-in+.user-mes-in{
        margin-top:10px;
    }
    .user-mes-name{
        width:120px;
        height:100%;
        line-height:30px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space:nowrap;
    }
    .user-mes-inp{
        width:calc(100% - 120px - 20px);
        height: 100%;
        box-sizing: border-box;
        border:1px solid #ccc;
        outline: none;
    }
    .share-time-box{
        width:100%;
        height:30px;
    }
    .share-time-top{
        margin-top:10px;
    }
    .user-mes-inp{
        width:24px;
        height:30px;
        box-sizing: border-box;
        border:1px solid #ccc;
        outline: none;
    }
    .share-time-sym{
        width:18px;
        height: 30px;
        line-height: 30px;
        text-align: center;
    }
    .share-time-btn{
        width:80px;
        height:30px;
        margin-left:10px;
        background-color: #EFF2F9;
        box-sizing: border-box;
        border:1px solid #364860;
        outline: none;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space:nowrap;
    }
    .share-time-btns{
        width:80px;
        height:30px;
        background-color: #EFF2F9;
        box-sizing: border-box;
        border:1px solid #364860;
        outline: none;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space:nowrap;
    }
    .share-time-btns+.share-time-btns{
        margin-left:10px;
    }
    .share-time-btns:nth-child(5){
        margin:0;
    }
    .share-time-btns:nth-child(n+5){
        margin-top:10px;
    }
    .share-time-btn-day{
        width:80px;
    }
    .user-mes-btn{
        width:100%;
        height:30px;
        margin-top:30px;
    }
    .user-mes-btn button{
        width:80px;
        height:100%;
        background-color: #EFF2F9;
        box-sizing: border-box;
        border:1px solid #364860;
        outline: none;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space:nowrap;
    }
    .user-mes-box .share-choice{
        color: #fff;
        background-color: #1F9DF1;
    }
</style>
<style scoped>
    @import '../assets/css/cloudPop.css';  
</style>





// WEBPACK FOOTER //
// src/components/ShareToFriend.vue